
import { Interval } from '@/model';
import Vue from 'vue';
import LabeledText, { Clip } from '@/components/LabeledText.vue';
import { GroupedInterval } from '@/util/text-selection';

export default Vue.extend({
  name: 'LabeledTextWithContext',
  components: { LabeledText },
  props: {
    text: { type: String, required: true },
    intervals: { type: Array as () => Array<Interval & { labels: readonly number[] }>, required: true },
    showContext: { type: Boolean, default: false },
  },

  data() {
    return {
      contextExpanded: false,
    };
  },

  computed: {
    showingContext(): boolean {
      return this.showContext || this.contextExpanded;
    },
    hasPreContext(): boolean {
      return !this.intervals.find((interval) => interval.from === 0);
    },
    hasPostContext(): boolean {
      return !this.intervals.find((interval) => interval.to === this.text.length);
    },
  },

  methods: {
    clipClicked(clip: GroupedInterval<Partial<Clip>>) {
      if (clip.group.length === 1 && clip.group[0].base) {
        this.contextExpanded = false;
      }
    },
  },
});
